import { datadogRum } from '@datadog/browser-rum';
import { getHostInfoFromPathname } from '@kiabi-com/common-configuration';
import packageJson from '../../package.json';
import logger from './logger';

export const initializeDatadog = () => {
    const hostInfo = getHostInfoFromPathname(window.location.pathname);
    const site = hostInfo?.site?.toUpperCase();
    if (!site) return;

    const applicationId =
        process.env[`REACT_APP_DD_RUM_APPLICATION_ID__${site}`];
    const clientToken = process.env[`REACT_APP_DD_RUM_TOKEN__${site}`];
    const env = process.env.REACT_APP_DATADOG_ENV;

    if (!applicationId || !clientToken) {
        logger.warn('Datadog RUM: Missing application ID or client token');
        return;
    }

    datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.eu',
        service: 'fcustomization',
        env,
        version: packageJson.version,
        enableExperimentalFeatures: ['feature_flags', 'long_animation_frame'],
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();
};
